
import React from "react";
import CEO from "../../../assets/perfiles/Director.jpeg";
import Director from "../../../assets/perfiles/roy.jpeg";
import Directora from "../../../assets/perfiles/rebe.jpeg";



const integrantes = [
    {
        id: 1,
        nombre: "Oscar Fredy González Rivera",
        cargo: "CEO & Fundador",
        imagen: CEO,
        descripcion:
            "Lidera la visión estratégica y el crecimiento de Vemasmas.",
    },
    {
        id: 2,
        nombre: "Rodrigo González",
        cargo: "Director de Operaciones",
        imagen: Director,
        descripcion:
            "Coordina las operaciones y la ejecución de los proyectos.",
    },
    {
        id: 3,
        nombre: "Rebeca Campos",
        cargo: "Directora General",
        imagen: Directora,
        descripcion:
            "Impulsa el desarrollo organizacional y la estrategia empresarial.",
    },
];

function EquipoGrid() {
    return (
        <section className="nosotros-equipo" id="equipo">
            <div className="nosotros-equipo__heading">
        <span className="nosotros-eyebrow">
          LAS PERSONAS DETRÁS DE CADA IDEA
        </span>

                <h2>
                    Conoce a nuestro
                    <br />
                    <span>equipo.</span>
                </h2>

                <p>
                    Personas que comparten una visión y trabajan
                    para transformar ideas en soluciones reales.
                </p>
            </div>

            <div className="nosotros-equipo__grid">
                {integrantes.map((integrante, index) => (
                    <article
                        className="integrante-card"
                        key={integrante.id}
                        style={{ "--card-index": index }}
                    >
                        <div className="integrante-card__image">
                            <img
                                src={integrante.imagen}
                                alt={integrante.nombre}
                                loading={index < 3 ? "eager" : "lazy"}
                            />

                            <span className="integrante-card__number">
                {String(integrante.id).padStart(2, "0")}
              </span>
                        </div>

                        <div className="integrante-card__info">
                            <div>
                                <h3>{integrante.nombre}</h3>
                                <p className="integrante-card__role">
                                    {integrante.cargo}
                                </p>
                            </div>

                            <p className="integrante-card__description">
                                {integrante.descripcion}
                            </p>
                        </div>
                    </article>
                ))}
            </div>
        </section>
    );
}

export default EquipoGrid;
